<template lang="pug">
.flex.items-start.flex-wrap
    .block.sidebar-filter-name(
        class="lg:w-2/12 w-full"
        v-bind:class="{'is-show' : filterShow}"
    )
        .mobile-only
            .header-filter.mb-4.flex.items-center.justify-between
                h2 Filter
                button.btn-icon.btn-icon-40(
                    v-on:click="filterShow = !filterShow"
                )
                    .icon-btn
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        .mb-3.w-full
            label.block.text-sm.font-bold.mb-2(for="fieldSelect") Gender
            .relative
                select.field-style(v-model="gender")
                    option(value="") All
                    //- template(v-if="search_by_name_marketplace.data && search_by_name_marketplace.data.length > 0")
                    option(v-for="(gender,index) in filter_gender" :value="gender") {{ gender }}
                    
                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
        .mb-3.w-full
            label.block.text-sm.font-bold.mb-2(for="fieldSelect") Year Of Birth
            .relative
                select.field-style(v-model="year_of_birth")
                    option(value="") All
                    template(v-if="year_of_birth_options.length > 0")
                        option(v-for="year in year_of_birth_options" :value="year") {{ year }}
                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>


        //- .mb-3.w-full
            label.block.text-sm.font-bold.mb-2(for="fieldSelect") Birth Date
            .relative.mr-3.field-date-time-picker
                date-range-picker(
                    v-if="dateRange.startDate && dateRange.endDate" 
                    ref="picker" 
                    v-model="dateRange" 
                    @update="pickerUpdate($event)" 
                    :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY' }" 
                    :date-format="dateFormat" 
                    opens="right" 
                    :ranges="default_ranges"
                    autoApply=true)
                    div(
                        slot="input" 
                        slot-scope="picker") 
                            | {{ picker.startDate | date}} - {{ picker.endDate  | date}}

                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>

        .mb-3.w-full
            label.block.text-sm.font-bold.mb-2(for="fieldSelect") Age Range
            .flex
                input.field-style(type="number" placeholder="Min Age" min="0" v-model="age_min")
                span.w-4
                input.field-style(type="number" placeholder="Max Age" min="0" v-model="age_max")

        .flex
            button.btn.btn-primary.flex-grow(type='button' @click="getData(true)") Filter
            button.btn.btn-default.flex-grow(type='button' @click="reset()") Reset

    .block(class="lg:w-10/12 lg:pl-8 p-0 w-full")
        .block(class="lg:py-4 p-4")
            //- .filter-info.text-light.flex.items-center.justify-between.mb-4
                .flex(class="lg:flex-row flex-col")
                    p(style="padding-right:4px") Showing data from 
                    span Jawa Barat, Kota Bandung
                .mobile-only
                    button.btn-primary-o(
                        type='button'
                        v-on:click="filterShow = !filterShow"
                    ) Change Filter
            .flex.items-center.justify-between
                .field.mr-2.relative.field--search
                    span Found {{ search_by_name_marketplace.total_data ? search_by_name_marketplace.total_data : 0 }} data
                .flex.flex-wrap.items-center
                    span.mr-2.m-hide Show
                    .field.relative
                        select.field-style#filter-record-size(@change="sizeChange($event)" v-model="items_per_page" style="min-width:80px")
                            option(v-for="(s,index) in size" :key="index" :value="s") {{ s }}
                        .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    span.ml-2.m-hide entries
        .table-static.w-full
            table
                thead
                    tr
                        th(v-for="(th, index) in tableThead" :key="index")
                            | {{ th.name }}
                tbody
                    tr(v-if="load_data_status_search_by_name_marketplace === 'loading'")
                        td.text-center(:colspan="tableThead.length")
                            .flex.flex-wrap.items-center.justify-center
                                Spinner(show="true" size="48")

                    template(v-else-if="search_by_name_marketplace.data && search_by_name_marketplace.data.length > 0")
                        tr(v-for="(data, index) in search_by_name_marketplace.data" :key="index")
                            //- td
                                router-link.link-text(v-if="data.content.full_name" :to="'/search-by-name/' + encrypt(data.content.full_name, 'name') ") {{ data.content.full_name }}
                                template(v-else) -
                            td {{ data.content.full_name ? data.content.full_name : '-' }}
                            td {{ data.content.sex ? data.content.sex : '-' }} {{ data.content.birth_date ? '(' + calculateAge(data.content.birth_date) + ')' : '' }}
                            td {{ data.content.birth_date ? data.content.birth_date : '-' }}
                            td
                                router-link.link-text(v-if="data.content.msisdn" :to="'/result/' + encrypt(data.content.msisdn, 'msisdn') + '/recent-location'") {{ data.content.msisdn }}
                                template(v-else) -
                            td
                                template(v-if="data.content.msisdn && data.content.msisdn === data.content.user_email") - 
                                router-link.link-text(v-else-if="data.content.user_email" :to="'/result/' + encrypt(data.content.user_email, 'email') + '/marketplace'") {{ data.content.user_email }}
                                template(v-else) -
                            td {{ data.content.location ? data.content.location : '-' }}

                    tr(v-else)
                        td.text-center(:colspan="tableThead.length") No Data Available

            .mt-5
            vue-ads-pagination(
                :total-items="total_data"
                :items-per-page="items_per_page"
                :page="page"
                :max-visible-pages="5"
            )
                template(slot="buttons" slot-scope="props")
                    vue-ads-page-button(
                        v-for="(button, key) in props.buttons"
                        :key="key"
                        v-bind="button"
                        :class="{'bg-yellow-dark': button.active}"
                        @page-change="page = button.page"
                        @range-change="start = button.start; end = button.end"
                    )
</template>

<script>
import { mapState } from 'vuex';
import { encrypt,decrypt } from '@/util/crypto';
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';
// import DateRangePicker from 'vue2-daterange-picker';
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
// import moment from 'moment';

export default {
    name: 'SourceMarketplace',
    components: {
        Spinner,
        VueAdsPagination,
        VueAdsPageButton,
        // DateRangePicker,
    },
    data(){
        return {
            filterShow: false,
            dataName: [
                {
                    name: 'Devi Krisdiansyah',
                    msisdn: '0987654321',
                    email: 'devi.krisdiansyah@mail.com', 
                    gender: 'L',
                    age: 40,
                    birthday: '10 agustus 2020',
                    address:'-',
                },
                {
                    name: 'Sally Brown',
                    msisdn: '0981234567821',
                    email: 'sally.brown@mail.com', 
                    gender: 'P',
                    age: 40,
                    birthday: '10 agustus 2020',
                    address:'-',
                },
                {
                    name: 'Joshua Jordan',
                    msisdn: '08512347890',
                    email: 'joshua.jordan@mail.com', 
                    gender: 'L',
                    age: 40,
                    birthday: '10 agustus 2020',
                    address:'-',
                },
                {
                    name: 'Abigail Olson',
                    msisdn: '086545673187',
                    email: 'abigail.olson@mail.com', 
                    gender: 'P',
                    age: 40,
                    birthday: '10 agustus 2020',
                    address:'-',
                },
                {
                    name: 'Leslie Gutierrez',
                    msisdn: '08765476876541',
                    email: 'leslie.gutierrez@mail.com', 
                    gender: 'P',
                    age: 40,
                    birthday: '10 agustus 2020',
                    address:'-',
                },
            ],

            tableThead: [
                {
                    name: 'Name',
                    // number: true,
                },{
                    name: 'Gender',
                },{
                    name: 'Birth Date',
                },{
                    name: 'MSISDN',
                },{
                    name: 'Email',
                },{
                    name: 'Address',
                },
            ],
            keyword: '',
            data_result: [],

            // pagination
            total_data: 0,
            items_per_page: 10,

            size: [10, 25, 50, 100],

            page: 0,
            start: 0,
            end: 0,

            // for filter
            gender: '',
            year_of_birth_data: '',
            birth_date: '',
            age_min: '',
            age_max: '',

            filter_gender: ['L', 'P'],
            timeout: null,

            // dateRange: {
            //     startDate: '',
            //     endDate: '',
            // },
            // default_ranges: {
            //     'Today': [moment().toDate(), moment().toDate()],
            //     'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
            //     // 'This month': [moment().startOf('month'), moment().endOf('month')],
            //     // 'This year': [moment().startOf('year'), moment().endOf('year')],
            //     'Last 7 days': [moment().subtract(6, 'days').toDate(), moment().toDate()],
            //     'Last week': [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()],
            //     // 'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            // },
        }
    },
    computed: {
        ...mapState([
            'load_data_status_search_by_name_marketplace',
            'search_by_name_marketplace',
        ]),
        route_name() {
            return this.$route.name;
        },
        key() {
            return this.$route.params.key;
        },
        isKey() {
            // return this.key!==undefined ? true : false;
            return this.key ? true : false;
        },
        year_of_birth: {
            get() {
                let data = this.year_of_birth_data;
                // if (this.year_of_birth_data === '') {
                //     const finish_year = new Date().getFullYear();
                //     data = finish_year - 16;
                // }

                return data;
            },
            set(v) {
                this.year_of_birth_data = v;
            },
        },
        year_of_birth_options() {
            const start_year = 1900;
            const finish_year = new Date().getFullYear();

            let options = [];
            let count_year = finish_year;

            for (var i = (finish_year + 1); i >= (start_year + 1); i--) {
                options.push(count_year--);
            }

            return options;
        },
    },
    watch: {
        route_name(newData, oldData) {
            if (newData === 'PageName') {
                if (oldData !== 'PageName') {
                    this.items_per_page = 10;
                    this.page = 0;
                    // this.keyword = '';
                    // this.$store.commit('setSearchByNameMarketplace', {});
                }
                // this.getData();
            }
        },
        key() {
            // if (this.route_name === 'PageName')
            this.gender = '';
            // this.birth_date = '';
            this.year_of_birth = '';
            this.age_min = '';
            this.age_max = '';

            // this.page = 0;
            // this.getData(true);
            this.$store.commit('setSearchByNameMarketplace', []);
        },
        isKey() {},
        breadcrumb() {},

        search_by_name_marketplace(newData) {
            if (Object.keys(newData).length > 0) {
                this.total_data = parseInt(newData.total_data);
                // this.page = (parseInt(newData.current_page) - 1);
            }
        },
        total_data() {
            // this.pagination();
        },
        items_per_page() {
            this.getData();
            // this.pagination();
        },
        page() {
            this.getData();
        },
        gender() {},
        year_of_birth() {},
        year_of_birth_options() {},
        // birth_date() {},
        age_min() {},
        age_max() {},
    },
    methods: {
        encrypt(key, type) {

            // remove space in prefix
            if (key.substr(0, 1) === ' ')
                key = key.substr(1, (key.length - 1));

            if (type === 'msisdn') {

                let prefix_key = key.substr(0, 1);

                if (prefix_key === 0 || prefix_key === '0') {
                    key = '62' + key.substr(1, (key.length - 1));
                } else if (key.substr(0, 4) === '+620') {
                    key = '62' + key.substr(4, (key.length - 4));
                } else if (prefix_key === '+') {
                    key = key.substr(1, (key.length - 1));
                }
            }

            return encrypt(key + '&&' + type);
        },
        calculateAge(dob) {

            dob = dob.split('-');
            let date = new Date(parseInt(dob[0]), (parseInt(dob[1]) - 1), parseInt(dob[2]));
            
            var diff_ms = new Date() - date.getTime();
            var age_dt = Math.floor(diff_ms / (1000 * 60 * 60 * 24 * 365.2425));

            return age_dt;
        },
        async getData(filter=false) {
            if (this.route_name === 'PageName' ) {
                // const default_date = this.$store.getters.getDefaultDate();

                // this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
                // this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();

                // this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                // this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                if (this.isKey) {

                    if (filter)
                        this.page = 0;

                    let decrypt_data = decrypt(this.key);
                    decrypt_data = decrypt_data.split('&&');

                    var key = decrypt_data[0];
                    // var type = decrypt_data[1];

                    this.keyword = key;

                    // gender='', birth_date='', age_min='', age_max=''

                    // await this.$store.dispatch('getSearchByNameMarketplace', [key, this.items_per_page, (this.page + 1), this.gender, this.birth_date, this.age_min, this.age_max]);
                    await this.$store.dispatch('getSearchByNameMarketplace', [key, this.items_per_page, (this.page + 1), this.gender, this.year_of_birth, this.age_min, this.age_max]);
                
                    this.pagination();
                    
                } else {
                    this.$store.commit('setSearchByNameMarketplace', []);
                }                
            }
        },
        reset() {

            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset?',
                // text: 'Role : ' + name,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                // console.log('on result');
                if (result.isConfirmed) {
                    this.gender = '';
                    this.year_of_birth = '';
                    this.age_min = '';
                    this.age_max = '';

                    this.getData(true);
                }
            });

        },
        // pagination
        pageChange(page) {
            this.page = page;
        },
        rangeChange(start, end) {
            this.start = start;
            this.end = end;
        },
        sizeChange() {
            this.page = 0;
        },
        pagination() {
            // update fontawesome to iconfont
            var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

            if (paginationButtonPreview[0]) {
                var classListPrev = paginationButtonPreview[0].classList;

                if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonPreview[0].classList.add('iconfont');
                    paginationButtonPreview[0].classList.add('iconleft');
                    paginationButtonPreview[0].style.fontSize = '12px';
                }
            }

            var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

            if (paginationButtonNext[0]) {
                var classListNext = paginationButtonNext[0].classList;

                if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonNext[0].classList.add('iconfont');
                    paginationButtonNext[0].classList.add('iconright');
                    paginationButtonNext[0].style.fontSize = '12px';
                }
            }
        },
        // datetimeFormat(datetime) {
        //     return moment(datetime, 'YYYY-MM-DDThh:mm:ssZ').format('DD MMM YYYY HH:mm:ssZ');
        // },
        // /* eslint-disable no-unused-vars */
        // dateFormat (classes, date) {
        //     if (!classes.disabled) {
        //         // console.log('on dateFormat')
        //         // console.log(moment(date.getTime())._d)

        //         // classes.disabled = date.getTime() > new Date();
        //         classes.disabled = moment(date.getTime()).subtract({ hours: 12})._d > new Date();
        //     }
        //     return classes;
        // },
        // async pickerUpdate(e) {
        //     // console.log('========= DateRangePicker on update')
        //     // console.log(e)

        //     let ranges = moment(e.endDate.getTime()).diff(moment(e.startDate.getTime()), 'days') + 1;

        //     if (this.isAstro !== 'true' && ranges > 7) {
        //         const default_date = this.$store.getters.getDefaultDate();

        //         // this.dateRange.startDate = moment().toDate();
        //         // this.dateRange.endDate = moment().toDate();

        //         // this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
        //         // this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

        //         this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
        //         this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();

        //         this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
        //         this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

        //         this.$swal.fire({
        //             icon: 'error',
        //             title: 'Date range is not more than 7 days!',
        //             text: 'Your date range is ' + ranges + ' days.',
        //             // confirmButtonText: 'Yes!',
        //             // confirmButtonColor: '#DD6B55',
        //             // showCancelButton: true,
        //             // allowOutsideClick: false,
        //         })

        //         // return;
        //     } else {
        //         this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
        //         this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

        //         this.getData();
        //     }
        // },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
    },
    mounted() {
        // console.log('on marketplace')
        EventEmit.$on('openSearchByNameMarketplace', () => {
            // this.getData();
            if (this.page !== 0) {
                this.page = 0;
            } else {
                this.getData();
            }
        });
    },
}
</script>